import { useState } from 'react';
import { navLinks, tickerFeed } from '@/mocks/home';

export default function UpdateTickerBar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="sticky top-0 z-50">
      <div className="bg-primary-600 text-background-50">
        <div className="flex h-9 items-center gap-3 px-4 md:px-8">
          <span className="flex shrink-0 items-center gap-1.5 font-label text-[11px] tracking-wide">
            <i className="ri-live-line text-sm" />
            实时更新
          </span>
          <span className="hidden h-3 w-px bg-background-50/40 sm:block" />
          <div className="overflow-hidden">
            <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
              {[...tickerFeed, ...tickerFeed].map((item, index) => (
                <span key={index} className="text-xs text-background-50/90">
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <header className="border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="flex h-16 items-center justify-between gap-6 px-4 md:px-8">
          <h1 className="flex shrink-0 items-baseline gap-1">
            <a href="#top" className="font-heading text-xl tracking-tight text-foreground-950 md:text-2xl">
              蝌蚪黑料
            </a>
            <span className="hidden font-label text-[11px] tracking-[0.2em] text-foreground-400 sm:inline">
              TIMELINE
            </span>
          </h1>

          <nav className="hidden items-center gap-7 md:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#top"
              className="hidden items-center gap-2 whitespace-nowrap rounded-md border border-foreground-200 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 md:flex"
            >
              <i className="ri-search-line text-base" />
              检索事件
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-foreground-200 text-foreground-700 md:hidden"
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
            </button>
          </div>
        </div>

        {menuOpen ? (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
            <nav className="flex flex-col">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="border-b border-background-100 py-3 text-sm text-foreground-700"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
        ) : null}
      </header>
    </div>
  );
}